import { useEffect, useRef, useState } from "react";

export const useIsLoading = (maxWait = 10000) => {
  const [isWaiting, setIsWaiting] = useState<boolean>(true);
  const load = useRef(new Date());
  const intervalRef = useRef<ReturnType<typeof setInterval> | null>(null);
  useEffect(() => {
    if (isWaiting) {
      if (!intervalRef.current) {
        intervalRef.current = setInterval(() => {
          if (document?.readyState === "complete") {
            setIsWaiting(false);
          }
        }, 200);
      }
    } else {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
    }
  }, [isWaiting]);

  useEffect(() => {
    const diff = load.current.getTime() - new Date().getTime(); // 1 ms later = -1
    const waitLeft = maxWait + diff;
    if (waitLeft > 0) {
      const timeoutId = setTimeout(() => {
        setIsWaiting(false);
      }, waitLeft);

      return () => clearTimeout(timeoutId);
    } else setIsWaiting(false);
  }, [setIsWaiting, maxWait]);
  return isWaiting;
};
